/** Converts PT-PT strings to PT-BR vocabulary for the Brazilian storefront. */
const RULES: [RegExp, string][] = [
  [/\bTelemóvel\b/g, "Celular"], [/\btelemóvel\b/g, "celular"],
  [/\bContacto(s)?\b/g, "Contato$1"], [/\bcontacto(s)?\b/g, "contato$1"],
  [/\bContactar\b/g, "Entrar em contato"], [/\bcontactar\b/g, "entrar em contato"],
  [/\bEncomenda(s)?\b/g, "Pedido$1"], [/\bencomenda(s)?\b/g, "pedido$1"],
  [/\bencomendar\b/g, "comprar"],
  [/\bCriar Conta Empresarial\b/g, "Cadastrar Empresa"], [/\bCriar Conta\b/g, "Cadastrar"], [/\bRegisto\b/g, "Cadastro"], [/\bregisto\b/g, "cadastro"],
  [/\bRegistar\b/g, "Cadastrar"], [/\bregistar\b/g, "cadastrar"],
  [/\bMorada(s)?\b/g, "Endereço$1"], [/\bmorada(s)?\b/g, "endereço$1"],
  [/\bCódigo Postal\b/g, "CEP"], [/\bcódigo postal\b/g, "CEP"],
  [/\bNIF\b/g, "CNPJ"],
  [/\bPortes\b/g, "Frete"], [/\bportes\b/g, "frete"],
  [/\bEquipa\b/g, "Equipe"], [/\bequipa\b/g, "equipe"],
  [/\bUtilizador(es)?\b/g, "Usuário$1"], [/\butilizador(es)?\b/g, "usuário$1"],
  [/\bPalavra-passe\b/g, "Senha"], [/\bpalavra-passe\b/g, "senha"],
  [/\bIniciar sessão\b/g, "Entrar"], [/\bTerminar sessão\b/g, "Sair"],
  [/\bactual\b/g, "atual"], [/\bfactura(s)?\b/g, "fatura$1"],
  [/\bem Portugal\b/g, "no Brasil"], [/\bPortugal\b/g, "Brasil"],
  [/\bContacte-nos\b/g, "Fale conosco"], [/\bcontacte-nos\b/g, "fale conosco"],
  [/\bContacte\b/g, "Fale com"], [/\bcontacte\b/g, "fale com"],
  [/\bPedir Orçamento\b/g, "Solicitar Orçamento"],
  [/\bConsumíveis\b/g, "Consumíveis"],
  [/\bTransformar o Seu Negócio\b/g, "Transformar Seu Negócio"],
  [/\bo seu\b/g, "seu"], [/\ba sua\b/g, "sua"], [/\bos seus\b/g, "seus"], [/\bas suas\b/g, "suas"],
  [/\bO seu\b/g, "Seu"], [/\bA sua\b/g, "Sua"],
  [/\bCarrinho de compras\b/g, "Carrinho"],
  [/\bfacturação\b/g, "faturamento"], [/\bFaturação\b/g, "Faturamento"], [/\bfaturação\b/g, "faturamento"],
  [/\bTelefone\/Telemóvel\b/g, "Telefone/Celular"],
  [/\bA carregar\b/g, "Carregando"], [/\ba carregar\b/g, "carregando"],
  [/\bGuardar\b/g, "Salvar"], [/\bguardar\b/g, "salvar"],
  [/\bEcrã\b/g, "Tela"], [/\becrã\b/g, "tela"],
  [/\bAcompanhar Pedido\b/g, "Rastrear Pedido"],
  [/\bIVA\b/g, "impostos"],
  [/\bempresarial\b/g, "empresarial"],
];

export function convertPtBR(s: string): string {
  return RULES.reduce((acc, [re, to]) => acc.replace(re, to), s);
}

export function toPtBR<T>(obj: T): T {
  if (typeof obj === "string") return convertPtBR(obj) as T;
  if (Array.isArray(obj)) return obj.map(toPtBR) as T;
  if (obj && typeof obj === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) out[k] = toPtBR(v);
    return out as T;
  }
  return obj;
}
